import axiosInstance from "../../../core/api/axios";
import {ILesson} from "../models/lesson";

export async function getLessonDetails(slug: string): Promise<ILesson> {
  try {
    const response = await axiosInstance.get(`/lessons/${slug}`)

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
